import { TableContainer } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import styled from "styled-components";

const StyledTable = styled(Table)`
  &.MuiTable-root {
    width: 100%;
    margin-bottom: 12px;
    box-sizing: border-box;
    border-spacing: 0 0;
    border-collapse: separate;
    background-color: #fff;
    /* Square. A radius only made sense while the table sat on a tinted page as
       a distinct card; as a full-width sheet it just rounds off rows. */
    border-radius: 0;
    /* No frame at all, and no shadow. The shadow was lifting the table off a
       tinted page and only smudged the edge against white; a box then drew a
       line above the header and under the last row that duplicated what the
       header fill and the row rules already do. */
    border: none;
    box-shadow: none;
  }
`;
const StyledTableHead = styled(TableHead)`
  /* Transparent: the fill lives on the cells instead, because a <thead>'s own
     square background cannot be rounded and would overhang the top corners. */
  &.MuiTableHead-root {
    background-color: transparent;
    padding: 1.25rem 2rem;
  }
  .MuiTableCell-head {
    background-color: var(--cc-grid-header-bg, #f5f7f9);
  }

  /* Style for sticky header */
  .MuiTableCell-stickyHeader {
    background-color: var(--cc-grid-header-bg, #f5f7f9) !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 100 !important;
  }
`;
const StyledTableRow = styled(TableRow)`
  &.MuiTableRow-root {
    background-color: white;
    width: 100%;
    flex: 1;
  }

  ${StyledTableHead} &.MuiTableRow-root {
    background-color: inherit;
  }

  &.MuiTableRow-root .MuiTableRow-hover:hover,
  &.MuiTableRow-root .Mui-selected {
    background-color: rgb(237 244 255);
  }
  &.MuiTableRow-root[data-clickable="true"] {
    cursor: pointer;
    &:hover {
      background-color: rgb(237 244 255);
    }
  }
`;

const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12px;
    line-height: 18px;
    color: var(--cc-grid-header-text, #2b313a);
    font-weight: 700;
    text-transform: capitalize;
  }
  &.MuiTableCell-root {
    line-height: 24px;
    padding: 1.25rem 0 1.25rem 16px;

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
  }
`;

const StyledTableBoreredCell = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12px;
    line-height: 18px;
    color: var(--cc-grid-header-text, #2b313a);
    font-weight: 700;
    text-transform: capitalize;
  }
  &.MuiTableCell-root {
    line-height: 24px;
    padding: 0.4rem 0 0.4rem 16px;

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
    &:not(:last-child) {
      border-right: 1px solid rgba(224, 224, 224, 1);
    }
  }
`;

const StyledRosterCell = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12.5px;
    line-height: 20px;
    color: var(--cc-grid-header-text, #2b313a);
    font-weight: 700;
    text-transform: capitalize;
    background: var(--cc-grid-header-bg, #f5f7f9);
    border-bottom: 1px solid var(--cc-grid-header-line, #dfe4ea);
    letter-spacing: 0.01em;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  &.MuiTableCell-root {
    /* Pinned height: the role band sticks at (strip top + this), see --rota-head-h. */
    height: var(--rota-head-h, 44px);
    box-sizing: border-box;
    line-height: 24px;
    padding: 0 0 0 18px;
    background: var(--cc-grid-header-bg, #f5f7f9);
    border-bottom: 1px solid var(--cc-grid-header-line, #dfe4ea);
    font-size: 12.5px;
    font-weight: 700;
    color: var(--cc-grid-header-text, #2b313a);
    &:first-child {
      padding-left: 1.5rem;
      border-left: none;
      border-top-left-radius: 0;
    }
    &:last-child {
      border-top-right-radius: 0;
      border-right: none;
    }
  }
`;

const CleanCell = styled(TableCell)`
  &.MuiTableCell-root {
    border: none;
    padding: 0;
  }
`;

const StyledCellSm = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12px !important;
    line-height: 12px;
    color: #0a0a29;
    font-weight: 700;
    text-transform: capitalize;
  }
  &.MuiTableCell-root {
    font-size: 12px !important;
    line-height: 12px;
    padding: 0.7rem 0 0.7rem 18px;

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
  }
`;

const StyledTableContainer = styled(TableContainer)`
  &.MuiTableContainer-root {
    overflow: hidden;
    border-radius: 1rem;
  }
`;

export {
  StyledTable,
  StyledTableHead,
  StyledTableRow,
  StyledTableCell,
  CleanCell,
  StyledCellSm,
  StyledRosterCell,
  StyledTableBoreredCell,
  StyledTableContainer,
};
